import { Endpoint } from "../config";

export type CompanyEndpointType =
  | "companyList"
  | "clientProfilesList"
  | "clientInviteRequest"
  | "clientPendingRequest"
  | "clientRejectedRequest"
  | "tierCompanyList"
  | "permissionProfilesListByCompanyId"
  | "commodityList"
  | "contactsList"
  | "tierMasterProfiles"
  | "debtorTypes"
  | "paymentTermsList"
  | "clientTypes"
  | "professions";

export const companyEndpoints: Record<CompanyEndpointType, Endpoint> = {
  companyList: {
    url: "company-list/",
  },
  clientProfilesList: {
    url: "client-profiles-list/",
  },
  clientInviteRequest: {
    url: "client-invite-request/",
  },
  clientPendingRequest: {
    url: "client-pending-request/",
  },
  clientRejectedRequest: {
    url: "client-rejected-request/",
  },
  tierCompanyList: {
    url: "tier-companies",
  },
  permissionProfilesListByCompanyId: {
    url: "company-permission-profiles",
  },
  commodityList: {
    url: "commodity-list/",
  },
  debtorTypes: {
    url: "debtor-type-list/",
  },
  paymentTermsList: {
    url: "payment-term-list/",
  },
  clientTypes: {
    url: "client-type-list/",
  },
  professions: {
    url: "profession-list/",
  },
  contactsList: {
    url: "contacts/",
  },
  tierMasterProfiles: {
    url: "tier-master-profiles/",
  },
};
